// extracted by mini-css-extract-plugin
export var togglePolicy = "togglePolicy-module--togglePolicy--NHSmY";
export var textPolicy = "togglePolicy-module--textPolicy--LhrGu";
export var secondary = "togglePolicy-module--secondary--BXhzU";
export var switcher = "togglePolicy-module--switcher--hn5VH";
export var input = "togglePolicy-module--input--QMhr-";
export var slider = "togglePolicy-module--slider--0YQXk";